import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useContext,
} from "react";
import { AuthContext } from "../../context/AuthContext";
import Grid from "@mui/material/Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import PulseLoader from "react-spinners/PulseLoader";
import { useNavigate } from "react-router-dom";
import { getDataWithToken } from "../../services/GetDataService";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { handlePostData } from "../../services/PostDataService";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Chip from "@mui/material/Chip";
import OutlinedInput from "@mui/material/OutlinedInput";
import ImageUpload from "../../utils/ImageUpload";

const AddInvestment = ({ getData }) => {
  const navigate = useNavigate();
  const { login, unity_fund_admin_panel, logout } = useContext(AuthContext);

  const [addInvestmentDialog, setAddInvestmentDialog] = useState(false);
  const [investmentId, setInvestmentId] = useState("");
  const [investmentDate, setInvestmentDate] = useState(dayjs());
  const [userIds, setUserIds] = useState([]);
  const [amount, setAmount] = useState("");
  const [profit, setProfit] = useState("");
  const [investmentDuration, setInvestmentDuration] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [bankName, setBankName] = useState("");
  const [transactionNo, setTransactionNo] = useState("");
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [userList, setUserList] = useState([]);
  const [file, setFile] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleDialogClose = (event, reason) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      console.log("handleDialogClose");
      clearForm();
      setAddInvestmentDialog(false);
    }
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const validation = () => {
    let isError = false;

    if (!investmentId.trim()) {
      handleSnakbarOpen("Please enter investment ID", "error");
      document.getElementById("investment_id").focus();
      return (isError = true);
    }

    if (!investmentDate) {
      handleSnakbarOpen("Please select investment date", "error");
      return (isError = true);
    }

    if (!userIds || userIds.length === 0) {
      handleSnakbarOpen("Please select at least one user", "error");
      return (isError = true);
    }

    if (!amount || parseFloat(amount) <= 0) {
      handleSnakbarOpen("Please enter valid amount", "error");
      document.getElementById("amount").focus();
      return (isError = true);
    }

    return isError;
  };

  const clearForm = () => {
    console.log("clearForm");
    setInvestmentId("");
    setInvestmentDate(dayjs());
    setUserIds([]);
    setAmount("");
    setProfit("");
    setInvestmentDuration("");
    setCompanyName("");
    setCompanyAddress("");
    setBankName("");
    setTransactionNo("");
    setRemarks("");
    setFile(null);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (validation()) {
      return;
    }

    setLoading(true);

    var formdata = new FormData();
    formdata.append("investment_id", investmentId.trim());
    formdata.append(
      "investment_date",
      dayjs(investmentDate).format("YYYY-MM-DD")
    );
    userIds.forEach((userId) => {
      formdata.append("user_ids[]", userId);
    });
    formdata.append("amount", parseFloat(amount).toFixed(2));
    if (profit) {
      formdata.append("profit", parseFloat(profit).toFixed(2));
    }
    if (investmentDuration) {
      formdata.append("investment_duration", parseInt(investmentDuration));
    }
    if (companyName.trim()) {
      formdata.append("company_name", companyName.trim());
    }
    if (companyAddress.trim()) {
      formdata.append("company_address", companyAddress.trim());
    }
    if (bankName.trim()) {
      formdata.append("bank_name", bankName.trim());
    }
    if (transactionNo.trim()) {
      formdata.append("transaction_no", transactionNo.trim());
    }
    if (remarks.trim()) {
      formdata.append("remarks", remarks.trim());
    }
    if (file) {
      formdata.append("document", file);
    }

    let response = await handlePostData(
      "/api/v1/investment/create",
      formdata,
      true
    );

    console.log("response", response);
    if (response?.status === 401) {
      logout();
      return;
    }
    if (response.status >= 200 && response.status < 300) {
      setLoading(false);
      handleSnakbarOpen("Added successfully", "success");
      clearForm();
      if (getData) {
        getData();
      }
      handleDialogClose();
    } else {
      setLoading(false);
      handleSnakbarOpen(
        response?.data?.message || "Error adding investment",
        "error"
      );
    }
  };

  const customeTextFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {},
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "",
      },
      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const customeSelectFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    background: "#ffffff",
    "& label.Mui-focused": {
      color: "#E5E5E5",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {},
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#",
      },
      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const custopDatePickerFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    background: "#ffffff",
    "& .MuiInputBase-root": {
      fontSize: "0.875rem",
      height: "2.5rem",
    },
    "& label.Mui-focused": {
      color: "#E5E5E5",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {},
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#",
      },
      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const getDropdownList = async () => {
    setLoading2(true);

    let url = `/api/v1/user/dropdownlist`;
    let allData = await getDataWithToken(url);
    console.log("allData?.data", allData?.data);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setUserList(allData?.data?.data || []);

      if (allData.data.data.length < 1) {
        handleSnakbarOpen("No users found", "warning");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };

  useEffect(() => {}, []);

  return (
    <>
      <Button
        variant="contained"
        disableElevation
        sx={{ py: 1.125, px: 2, borderRadius: "6px" }}
        onClick={() => {
          setAddInvestmentDialog(true);
          getDropdownList();
        }}
        startIcon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.99996 4.16675V15.8334M4.16663 10.0001H15.8333"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
      >
        Add Investment
      </Button>

      <Dialog
        open={addInvestmentDialog}
        onClose={handleDialogClose}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px",
          },
        }}
        PaperProps={{
          component: "form",
          onSubmit: onSubmit,
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            fontSize: "20px",
            fontFamily: '"Inter", sans-serif',
            fontWeight: 600,
            color: "#0F1624",
            position: "relative",
            px: 2,
            borderBottom: "1px solid #EAECF1",
          }}
        >
          Add Investment
          <IconButton
            sx={{ position: "absolute", right: 0, top: 0 }}
            onClick={() => handleDialogClose()}
          >
            <svg
              width="46"
              height="44"
              viewBox="0 0 46 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29 16L17 28M17 16L29 28"
                stroke="#656E81"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            maxWidth: "600px",
            minWidth: "600px",
            px: 2,
            borderBottom: "1px solid #EAECF1",
            my: 1,
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Investment ID
          </Typography>
          <TextField
            required
            size="small"
            fullWidth
            id="investment_id"
            placeholder="Enter Investment ID"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={investmentId}
            onChange={(e) => {
              setInvestmentId(e.target.value);
            }}
          />
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Investment Date
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              id="investmentDate"
              sx={{
                width: "100%",
                ...custopDatePickerFeild,
                mb: 3,
              }}
              format="DD/MM/YYYY"
              maxDate={dayjs()}
              value={investmentDate}
              onChange={(newValue) => {
                setInvestmentDate(newValue);
              }}
            />
          </LocalizationProvider>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Users
          </Typography>
          <FormControl
            fullWidth
            size="small"
            sx={{
              ...customeSelectFeild,
              "& label.Mui-focused": {
                color: "rgba(0,0,0,0)",
              },
              mb: 3,
            }}
          >
            <Select
              required
              multiple
              value={userIds}
              onChange={(e) => setUserIds(e.target.value)}
              input={<OutlinedInput label="Users" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => {
                    const user = userList.find((u) => u._id === value);
                    return (
                      <Chip
                        key={value}
                        label={user?.name || value}
                        size="small"
                      />
                    );
                  })}
                </Box>
              )}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 250,
                  },
                },
              }}
            >
              {userList.map((user) => (
                <MenuItem key={user._id} value={user._id}>
                  {user.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Amount
          </Typography>
          <TextField
            required
            type="number"
            size="small"
            fullWidth
            id="amount"
            placeholder="Enter Amount"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value);
            }}
            onWheel={(e) => e.target.blur()}
            inputProps={{ min: 0, step: 0.01 }}
          />
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Profit
          </Typography>
          <TextField
            type="number"
            size="small"
            fullWidth
            id="profit"
            placeholder="Enter Profit (Optional)"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={profit}
            onChange={(e) => {
              setProfit(e.target.value);
            }}
            onWheel={(e) => e.target.blur()}
            inputProps={{ min: 0, step: 0.01 }}
          />
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Investment Duration (Days)
          </Typography>
          <TextField
            type="number"
            size="small"
            fullWidth
            id="investment_duration"
            placeholder="Enter Investment Duration in Days (Optional)"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={investmentDuration}
            onChange={(e) => {
              setInvestmentDuration(e.target.value);
            }}
            onWheel={(e) => e.target.blur()}
            inputProps={{ min: 0 }}
          />
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Company Name
          </Typography>
          <TextField
            size="small"
            fullWidth
            id="company_name"
            placeholder="Enter Company Name (Optional)"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={companyName}
            onChange={(e) => {
              setCompanyName(e.target.value);
            }}
          />
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Company Address
          </Typography>
          <TextField
            size="small"
            fullWidth
            id="company_address"
            placeholder="Enter Company Address (Optional)"
            variant="outlined"
            multiline
            rows={2}
            sx={{ ...customeTextFeild, mb: 3 }}
            value={companyAddress}
            onChange={(e) => {
              setCompanyAddress(e.target.value);
            }}
          />
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Bank Name
          </Typography>
          <TextField
            size="small"
            fullWidth
            id="bank_name"
            placeholder="Enter Bank Name (Optional)"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={bankName}
            onChange={(e) => {
              setBankName(e.target.value);
            }}
          />
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Transaction Number
          </Typography>
          <TextField
            size="small"
            fullWidth
            id="transaction_no"
            placeholder="Enter Transaction Number (Optional)"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={transactionNo}
            onChange={(e) => {
              setTransactionNo(e.target.value);
            }}
          />
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Remarks
          </Typography>
          <TextField
            size="small"
            fullWidth
            id="remarks"
            placeholder="Enter Remarks (Optional)"
            variant="outlined"
            multiline
            rows={3}
            sx={{ ...customeTextFeild, mb: 3 }}
            value={remarks}
            onChange={(e) => {
              setRemarks(e.target.value);
            }}
          />
          <Box>
            <ImageUpload
              file={file}
              setFile={setFile}
              dimension="Size: (800 : 600)"
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 2 }}>
          <Button
            variant="outlined"
            onClick={handleDialogClose}
            sx={{
              px: 2,
              py: 1.25,
              fontSize: "14px",
              fontWeight: 600,
              color: "#344054",
              border: "1px solid #D0D5DD",
              boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            }}
          >
            Close
          </Button>
          <Button
            variant="contained"
            disabled={loading}
            type="submit"
            sx={{
              px: 2,
              py: 1.25,
              fontSize: "14px",
              fontWeight: 600,
              minWidth: "127px",
              minHeight: "44px",
            }}
            autoFocus
            disableElevation
          >
            <PulseLoader
              color={"#4B46E5"}
              loading={loading}
              size={10}
              speedMultiplier={0.5}
            />{" "}
            {loading === false && "Save changes"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddInvestment;
